import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../assets/hooks";
// import CommunityChatComponent from "../../genericComponents/communityChatComponent";
import { Chat} from "../../types/types";
import CommunityChatComponent from "../../components/communityChatComponent";

const CommunityChat = () => {
  const advisorchats = useAppSelector((state) => state.chats);

  return (
    <Box sx={{
      overflowY: "scroll",
      height: "450px",
      "&::-webkit-scrollbar": {
        width: "12px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#fff",
        borderRadius: "8px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#fff",
      },
      width:"100%",
      mt:2
    }}>
      <Grid container spacing={2} 
        sx={{mt:0,justifyContent:"center"}}
        >
      {advisorchats?.data?.community?.length > 0 ?advisorchats?.data?.community?.map((item: Chat,i) => (
        <Grid item xs={12} key={i}>
        <CommunityChatComponent data={item} />
        </Grid>
      )) : 
      <Box sx={{height:"5rem",borderRadius:"20px",display:"flex",justifyContent:"center",alignItems:"center"}}>
        <Typography color="#3B3F76">Start a new chat</Typography>
        </Box>
      }
      </Grid>
    </Box>
  );
};

export default CommunityChat;
